export const isLoading = "isLoading";

export const isError = "isError";

export const ADD_CART_DATA = "add/cart/data";

export const GET_CART_DATA = "get/cart/data";

export const DELETE_CART_DATA = "delete/cart/data";

export const ADD_WISHLIST_DATA = "add/wishlist/data";

export const GET_WISHLIST_DATA = "get/wishlist/data";

export const DELETE_WISHLIST_DATA = "delete/wishlist/data";
